/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { localizationListSchema } from "./localizationListSchema.ts";
import { localizationStrSchema } from "./localizationStrSchema.ts";
import { sizeSchema } from "./sizeSchema.ts";

export const modifierSchema = z.object({
	id: z.uuid(),
	name: z.string(),
	price: z.number().nullable(),
	sizes: z.array(sizeSchema),
	required: z.boolean().optional(),
	default_amount: z.int().min(0).max(2147483647).optional(),
	min_amount: z.int().min(0).max(2147483647).optional(),
	max_amount: z.int().min(0).max(2147483647).optional(),
	free_quantity: z.int().min(0).max(2147483647).nullish(),
	is_fake: z.boolean(),
	is_marked: z.boolean(),
	weight: z.number().nullable(),
	measure_unit: z.string().nullable(),
	fat_amount: z.number().nullable(),
	proteins_amount: z.number().nullable(),
	carbohydrates_amount: z.number().nullable(),
	energy_amount: z.number().nullable(),
	allergens: z.array(z.string()),
	image_link: z.string().nullable(),
	video_link: z.string().nullable(),
	loc_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
	loc_allergens: localizationListSchema.describe("Util serializer for representation in swagger"),
});
